import { createContext, useContext } from 'react';

export const TeethContext = createContext({
    baseTeethSelections: {
        toothForBiteRamp: [],
        setToothForBiteRamp: () => undefined,
        toothForPontics: [],
        setToothForPontics: () => undefined,
    },
    upperAndLowerTeethSelections: {
        upperToothForBiteRamp: [],
        setUpperToothForBiteRamp: () => undefined,
        upperToothForPontics: [],
        setUpperToothForPontics: () => undefined,
        lowerToothForBiteRamp: [],
        setLowerToothForBiteRamp: () => undefined,
        lowerToothForPontics: [],
        setLowerToothForPontics: () => undefined,
    },
});

const useTeethContext = () => {
    const context = useContext(TeethContext);
    if (!context) {
        throw new Error('context must be used within a Context Provider');
    }
    return context;
};

export default useTeethContext;
